import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga";
import { QRCodeSVG } from "qrcode.react";
import { FiClock } from "react-icons/fi";
import logo from "../../assets/cashlet.svg";
import "../../assets/css/common.css";
import "./automatic-deposit.css";

const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.cashlet";
const APP_STORE_URL =
  "https://apps.apple.com/us/app/cashlet-savings-investments/id6463010865";

const getStoreUrl = () => {
  if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
    return APP_STORE_URL;
  }
  return PLAY_STORE_URL;
};

const openCashletApp = () => {
  const storeUrl = getStoreUrl();
  const path = `${window.location.pathname}${window.location.search}`.replace(
    /^\//,
    ""
  );

  const startedAt = Date.now();
  const onVisibilityChange = () => {
    if (document.hidden) {
      window.clearTimeout(fallbackTimer);
      document.removeEventListener("visibilitychange", onVisibilityChange);
    }
  };
  document.addEventListener("visibilitychange", onVisibilityChange);

  const fallbackTimer = window.setTimeout(() => {
    document.removeEventListener("visibilitychange", onVisibilityChange);
    if (!document.hidden && Date.now() - startedAt >= 1400) {
      window.location.href = storeUrl;
    }
  }, 1600);

  window.location.href = `cashlet://${path}`;
};

const AutomaticDepositPage = () => {
  const location = useLocation();
  const [pageUrl, setPageUrl] = useState("");

  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  useEffect(() => {
    if (/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      openCashletApp();
    }
  }, []);

  useEffect(() => {
    setPageUrl(window.location.href);
  }, [location]);

  return (
    <>
      <div className="px-4 md:px-8 pt-8 md:pt-12 pb-4 md:pb-6 text-center">
        <img
          src={logo}
          alt="Cashlet"
          className="h-8 md:h-10 w-auto mx-auto mb-6 md:mb-12"
        />

        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full status-badge mb-5 md:mb-8">
          <FiClock className="w-4 h-4 text-custom-green flex-shrink-0" />
          <span className="text-sm text-primary-darkest">
            You have a DRIP deposit waiting for your approval
          </span>
        </div>

        <div className="md:hidden">
          <h1 className="landing-text normal-case text-3xl mt-8 mb-3">
            Continue in Cashlet
          </h1>
          <p className="text-muted text-base max-w-md mx-auto !pt-0 !pb-0">
            Open Cashlet to review this deposit and approve it on M-Pesa.
          </p>
        </div>

        <div className="hidden md:block">
          <h1 className="landing-text normal-case text-3xl md:text-5xl mb-4 md:mb-6">
            Open Cashlet on your phone
          </h1>
          <p className="text-muted text-base md:text-xl max-w-2xl mx-auto">
            This deposit can only be approved in the Cashlet mobile app.
          </p>
        </div>
      </div>

      <div className="px-4 md:px-8 pb-8 md:pb-16">
        <div className="max-w-xl mx-auto text-center">
          <div className="md:hidden mt-6 mb-20">
            <button
              type="button"
              onClick={openCashletApp}
              className="btn-primary open-app-btn w-full py-4 font-semibold text-base"
            >
              Open Cashlet on this phone
            </button>
          </div>

          <div className="hidden md:flex flex-col items-center mb-10">
            <div className="qr-frame rounded-2xl p-4 mb-4 mx-auto">
              {pageUrl ? (
                <QRCodeSVG value={pageUrl} size={180} includeMargin={false} />
              ) : (
                <div className="w-44 h-44 bg-gray-50" />
              )}
            </div>
            <p className="text-sm text-muted mb-8 text-center mx-auto">
              Scan with your phone to continue in Cashlet.
            </p>
            <div className="w-full border-t border-gray-200 pt-6">
              <p className="text-sm text-muted text-center">
                You can also open the Cashlet app and check your pending plan
                deposit.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AutomaticDepositPage;
